var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportExcelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h22v22H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M16.923 6.77h3.385V5.076h-3.385v1.692zm0 3.384h3.385V8.462h-3.385v1.692zm0 3.384h3.385v-1.692h-3.385v1.692zm0 3.385h3.385v-1.692h-3.385v1.692zm4.368-14.385h-7.753v2.525h2.565v1.719h-2.565v1.68h2.539v1.692h-2.539v1.692h2.539v1.692h-2.539v1.693h2.539v1.692h-2.539v2.539h7.753c.39 0 .709-.331.709-.737V3.275c0-.406-.319-.737-.71-.737zM8.028 15.299l-1.476-2.792c-.056-.104-.114-.295-.174-.574h-.023a4.271 4.271 0 0 1-.198.598l-1.481 2.768H2.375l2.731-4.285-2.498-4.286h2.349l1.225 2.57c.095.203.18.444.257.722h.024c.048-.167.138-.416.269-.747l1.362-2.546h2.151l-2.57 4.25 2.642 4.32-2.289.002zM0 2.445v17.111L12.692 22V0L0 2.445z",
    mask: "url(#b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportExcelIcon);
export default __webpack_public_path__ + "static/media/export-excel-icon.570634fc6e12408f44702c274de9455e.svg";
export { ForwardRef as ReactComponent };